import { Component, Input } from '@angular/core';
import { SynappsErrorMessage } from '@app/services/error.service';

@Component({
    selector: 'syn-error-message',
    templateUrl: './error-message.component.html',
    styleUrls: ['./error-message.component.scss']
})
export class ErrorMessageComponent {

    @Input() error: SynappsErrorMessage;

    get title() {
        return this.error?.error?.title || 'Une erreur est survenue';
    }

    get details() {
        return this.error?.error?.detail || 'Détails inconnus';
    }

    get correlationId() {
        return this.error?.error?.id;
    }
}
